export enum DrugSearchLevel {
  InterchangeStrengthGroup = 0,
  InterchangePackSizeGroup = 1,
}
